/* eslint-disable react/prop-types */
import * as React from 'react';

import { Table } from 'antd';

function PrimitiveTable<T>({
  tableLayout = 'fixed',
  scroll = { x: 700, y: 630 },
  pagination,
  ...props
}: React.ComponentPropsWithoutRef<typeof Table<T>>) {
  const paginationConfig: typeof pagination = pagination
    ? {
        position: ['bottomRight'],
        className: '[&_.ant-select]:h-8',
        responsive: true,
        showQuickJumper: true,
        ...pagination,
      }
    : pagination;

  return (
    <Table<T>
      tableLayout={tableLayout}
      scroll={scroll}
      pagination={paginationConfig}
      {...props}
    />
  );
}

export { PrimitiveTable };
